export interface AgoraParams {
    token: string
    appId: string
    channel: string
}

export interface ApiResponse<T> {
    code: number
    message: string
    data: T
}

const HTTP_PREFIX = 'https://apiv2.hellogeo.world'

const at =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InRlY2hAaGVsbG9nZW8ud29ybGQiLCJpZCI6MSwiaWF0IjoxNzU5MTM3NDkyLCJleHAiOjE3OTA2NzM0OTJ9.EA6B1CRZLE83nI7lCCdiEslTpSOL4c4qgw0Xfy_mRlQ'

export const fetchAgoraParams = async (): Promise<AgoraParams> => {
  const url = `${HTTP_PREFIX}/api/v1/admin/agora/token`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      at: at, // Custom header
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const result: AgoraParams = await response.json()
  return result
}
